import {
    Component, OnInit, Input, Inject,
    EventEmitter, ViewEncapsulation,
} from '@angular/core';
import { DialogModelBase } from '../dialog.model';

export class AlertData extends DialogModelBase {
    // 新属性
    title = '提示';
    content: string;

    constructor() {
        super();
        this.validFields.push('title', 'content');
    }
}

@Component({
    selector: 'jui-dialog-alert',
    template: `

      <jui-modal *ngIf="data" [isOpen]="data?.isOpen"
          [overlayClosable]="data?.overlayClosable"
          [boxStyle]="data?.baseStyle">
          <div class="alert-wrapper">
              <div class="modal-header">
                  <strong>{{data.title}}</strong>
              </div>
              <div class="modal-body">
                  <p class="desc">{{data.content}}</p>
              </div>
              <div class="modal-footer">
                  <div class="btns">
                      <button jui-btn (click)="onSure($event)">
                          {{data.sureTxt}}
                      </button>
                  </div>
              </div>
          </div>
      </jui-modal>
    `,
    styles: [`
      @font-face {
        font-family: 'iconfont';
        /* project id 290315 */
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot");
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot?#iefix") format("embedded-opentype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.woff") format("woff"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.ttf") format("truetype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.svg#iconfont") format("svg"); }

      .iconfont {
        display: inline-block;
        vertical-align: baseline;
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale; }

      .icon-jui-alert:before {
        content: "\\e600"; }

      .icon-jui-search:before {
        content: "\\e630"; }

      .icon-jui-paper3:before {
        content: "\\e652"; }

      .icon-jui-setting:before {
        content: "\\e602"; }

      .icon-jui-left2:before {
        content: "\\e697"; }

      .icon-jui-wrong:before {
        content: "\\e69a"; }

      .icon-jui-up2:before {
        content: "\\e6a5"; }

      .icon-jui-down2:before {
        content: "\\e6a6"; }

      .icon-jui-right2:before {
        content: "\\e6a7"; }

      .icon-jui-correct2:before {
        content: "\\e627"; }

      .icon-jui-qq:before {
        content: "\\e63a"; }

      .icon-jui-email:before {
        content: "\\e62a"; }

      .icon-jui-edit:before {
        content: "\\e686"; }

      .icon-jui-download2:before {
        content: "\\e714"; }

      .icon-jui-speaker:before {
        content: "\\e85c"; }

      .icon-jui-add:before {
        content: "\\e609"; }

      .icon-jui-msg:before {
        content: "\\e613"; }

      .icon-jui-minus:before {
        content: "\\e601"; }

      .icon-jui-up:before {
        content: "\\e658"; }

      .icon-jui-letter-open:before {
        content: "\\e61d"; }

      .icon-jui-down:before {
        content: "\\ed22"; }

      .icon-jui-info:before {
        content: "\\e685"; }

      .icon-jui-cross2:before {
        content: "\\e6b4"; }

      .icon-jui-paper2:before {
        content: "\\e71e"; }

      .icon-jui-loading:before {
        content: "\\eee3"; }

      .icon-jui-road-sign:before {
        content: "\\e604"; }

      .icon-jui-left:before {
        content: "\\e66a"; }

      .icon-jui-letter:before {
        content: "\\e605"; }

      .icon-jui-right:before {
        content: "\\e64d"; }

      .icon-jui-back-top:before {
        content: "\\e628"; }

      .icon-jui-dropdown:before {
        content: "\\e75a"; }

      .icon-jui-down3:before {
        content: "\\e629"; }

      .icon-jui-alarm:before {
        content: "\\e6c2"; }

      .icon-jui-paper:before {
        content: "\\e612"; }

      .icon-jui-cross:before {
        content: "\\e6b0"; }

      .icon-jui-correct:before {
        content: "\\e6b3"; }

      .icon-jui-up3:before {
        content: "\\eee4"; }

      .icon-jui-username:before {
        content: "\\e670"; }

      .icon-jui-password:before {
        content: "\\e615"; }

      .icon-jui-slideLeft:before {
        content: "\\e603"; }

      .icon-jui-slideRight:before {
        content: "\\e641"; }

      /* icon Animate */
      .icon-doTurn {
        -webkit-animation: doTurn 1s infinite linear;
        animation: doTurn 1s infinite linear; }

      @-webkit-keyframes doTurn {
        0% {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(0deg); }
        to {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(1turn); } }

      @keyframes doTurn {
        0% {
          transform-origin: 50% 50%;
          transform: rotate(0deg); }
        to {
          transform-origin: 50% 50%;
          transform: rotate(1turn); } }
      jui-dialog-alert ::ng-deep .main-container {
        max-width: 50%; }

      jui-dialog-alert .alert-wrapper {
        min-width: 300px; }
        jui-dialog-alert .alert-wrapper .modal-header {
          padding: 8px 10px;
          text-align: left;
          font-size: 14px;
          color: #777;
          border-bottom: 1px solid #eee; }
        jui-dialog-alert .alert-wrapper .modal-body {
          padding: 20px; }
          jui-dialog-alert .alert-wrapper .modal-body p.desc {
            font-size: 16px;
            color: #555;
            font-weight: 400;
            margin: 0; }
        jui-dialog-alert .alert-wrapper .modal-footer {
          padding: 10px;
          text-align: right; }
    `],
    encapsulation: ViewEncapsulation.None,
})
export class AlertComponent implements OnInit {

    constructor(public data: AlertData) { }

    ngOnInit() {
        // pass
    }
    public onSure(event) {
        this.data.isOpen = false;
        this.data.sure.emit(event);
    }
}
